import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  signInWithEmailAndPassword,
  sendSignInLinkToEmail,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth } from './firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

const ADMIN_EMAIL = 'dezamaxo@gmail.com';

const actionCodeSettings = {
  url: 'https://gandg.gg/finishSignIn',
  handleCodeInApp: true,
};

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  async function adminLogin(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  async function sendMagicLink(email) {
    const normalizedEmail = email.trim().toLowerCase();
    await sendSignInLinkToEmail(auth, normalizedEmail, actionCodeSettings);
    window.localStorage.setItem('emailForSignIn', normalizedEmail);
  }

  function logout() {
    return signOut(auth);
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setIsAdmin(user?.email === ADMIN_EMAIL);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const value = {
    loading,
    currentUser,
    isAdmin,
    adminLogin,
    sendMagicLink,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}
